module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-01.3ebe55d7.png";